<div class="margin-bottom-24" *ngIf="photos != null && photos.length > 0" [@fadeIn]>
  <panel heading="Mandatory Photos ({{side}} Side)">
    <div class="photo-container">
      <mandatory-component-photo *ngFor="let photo of photos" [side]="side == 'Left' ? 1 : 2" [mandatoryImageId]="photo.CustomerModelMandatoryImageId" [inspectionId]="inspectionId" [compartTypeId]="compartTypeId" [photoTitle]="photo.Title" [photoId]="photo.Id" [photoDescription]="photo.Description"></mandatory-component-photo>
    </div>
  </panel>
</div>
